module.exports = __webpack_public_path__ + "img/03_1_1_1.aefd1e84.png";